import jwt from "./jwt";

export const CONSENT_KEY = "consentGivenAt";
const CONSENT_VALID_DAYS = 90;

export const getEffectiveUserType = (decodedToken) => {
  return (
    sessionStorage.getItem("userType") ||
    (decodedToken.isElectricUser ? "ELECTRIC" : decodedToken.userType) ||
    "OPERATOR"
  );
};

export const shouldShowConsentPopup = () => {
  const token = localStorage.getItem("idToken");
  if (!token) return false;
  const decodedToken = jwt.decode(token);
  if (!decodedToken) return false;

  const effectiveUserType = getEffectiveUserType(decodedToken);
  if (effectiveUserType !== "OPERATOR" && effectiveUserType !== "CABOWNER")
    return false;

  const storedConsent = localStorage.getItem(CONSENT_KEY);
  if (storedConsent) {
    const daysDiff =
      (Date.now() - parseInt(storedConsent)) / (1000 * 60 * 60 * 24);
    if (daysDiff < CONSENT_VALID_DAYS) return false;
  }
  if (
    effectiveUserType === "OPERATOR" &&
    !decodedToken.isAdminUser &&
    !decodedToken.gdsUserConsentGivenOn
  ) {
    return true;
  }

  if (
    effectiveUserType === "CABOWNER" &&
    !decodedToken.isAdminUser &&
    !decodedToken.mgUserConsentGivenOn
  ) {
    return true;
  }

  if (decodedToken.isAdminUser && !decodedToken.adminUserConsentGivenOn) {
    return true;
  }

  let consentGivenOn;

  if (decodedToken.isAdminUser) {
    consentGivenOn = decodedToken.adminUserConsentGivenOn;
  } else if (effectiveUserType === "CABOWNER") {
    consentGivenOn = decodedToken.mgUserConsentGivenOn;
  } else {
    consentGivenOn = decodedToken.gdsUserConsentGivenOn;
  }

  const daysDiff =
    (Date.now() - new Date(consentGivenOn).getTime()) / (1000 * 60 * 60 * 24);
  return daysDiff >= CONSENT_VALID_DAYS;
};

export const markConsentGiven = () => {
  localStorage.setItem(CONSENT_KEY, Date.now().toString());
};

export const clearConsent = () => {
  localStorage.removeItem(CONSENT_KEY);
};
